import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, Modal, FormControlLabel, Checkbox, useMediaQuery, IconButton, Grid, InputAdornment } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CrossIcon from '../assests/croosicon.png';
import { styled } from '@mui/material/styles';
import CloseEyeIcon from '../../common/assests/eclose.svg';
import OpenEyeIcon from '../../common/assests/eopen.svg';
// Styled Checkbox component
const CustomCheckbox = styled(Checkbox)(({ theme }) => ({
  '& .MuiCheckbox-root': {
    color: '#065F46',
  },
  '& .Mui-checked': {
    color: '#065F46',
  },
}));

const permissions = [
  "Dashboard",
  "User Management",
  "Vendor Management",
  "Orders",
  "Content Management",
  "Reports & Analysis",
  "Event Management",
  "Push Notification",
  "Help & Support"
];

const EditUserPermission = ({ open, onClose, onSave, editingData }) => {
  const isSmallScreen = useMediaQuery('(max-width:576px)');
  const gridSpacing = isSmallScreen ? 1 : 2;

  // State to manage edited user data
  const [editData, setEditData] = useState({
    userName: '',
    email: '',
    mobile: '',
    password: '',
    retypePassword: '',
    permissions: Array(permissions.length).fill(false),
  });

  // Populate editData when editingData is passed
  useEffect(() => {
    if (editingData) {
      setEditData({
        userName: editingData.username || '',
        email: editingData.email || '',
        mobile: editingData.phone || '',
        password: '',
        retypePassword: '',
        permissions: Object.values(editingData.permissions || {}),
      });
    }
  }, [editingData]);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditData((prevData) => ({ ...prevData, [name]: value }));
  };

  // Handle checkbox toggles
  const handleCheckboxChange = (index) => {
    setEditData((prevData) => {
      const updatedPermissions = [...prevData.permissions];
      updatedPermissions[index] = !updatedPermissions[index];
      return { ...prevData, permissions: updatedPermissions };
    });
  };

  // Save updated data
  const handleSave = () => {
    const updatedUserData = {
      username: editData.userName,
      email: editData.email,
      phone: editData.mobile,
      password: editData.password,
      retypePassword: editData.retypePassword,
      permissions: editData.permissions, 
    };
    onSave(updatedUserData);
    onClose();
  };


  useEffect(() => {
    
    if (!open) {
      setShowPasswords({
        newPassword: false,
        confirmNewPassword: false,
      });
    }
  }, [open]);
  

  
  const [showPasswords, setShowPasswords] = useState({
    newPassword: false,
    confirmNewPassword: false,
  });

  const handleClickShowPassword = (field) => {
    setShowPasswords((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };


  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-title" aria-describedby="modal-description">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: isSmallScreen ? '94%' : '540px',
          bgcolor: 'background.paper',
          borderRadius: '16px',
          boxShadow: 24,
          p: 4,
          maxHeight: '90vh',
          overflowY: 'auto',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography id="modal-title" sx={{ fontSize: '20px', color: '#362B24', fontWeight: '700' }}>
            Edit User Permissions
          </Typography>
          <IconButton onClick={onClose}>
            <img src={CrossIcon} alt="Close" style={{ height: '20px', width: '20px' }} />
          </IconButton>
        </Box>

        {/* User Name Field */}
        <Typography sx={{ marginBottom: '8px', fontSize: '17px', fontWeight: '600', marginTop: '25px' }}>
          User Name
        </Typography>
        <TextField
          fullWidth
          name="userName"
          value={editData.userName}
          onChange={handleInputChange}
          placeholder="Type user name"
          sx={{
            borderRadius: '28px',
            border: '1px solid #362B24',
            '& .MuiOutlinedInput-root': {
              borderRadius: '25px',
            },
          }}
        />

        {/* Email Field */}
        <Typography sx={{ marginBottom: '8px', fontSize: '17px', fontWeight: '600', marginTop: '15px' }}>
          Email
        </Typography>
        <TextField
          fullWidth
          disabled
          name="email"
          type="email"
          value={editData.email}
          onChange={handleInputChange}
          placeholder="Type your email"
          sx={{
            borderRadius: '28px',
            border: '1px solid #362B24',
            '& .MuiOutlinedInput-root': {
              borderRadius: '25px',
            },
          }}
        />

        {/* Mobile Number Field */}
        <Typography sx={{ marginBottom: '8px', fontSize: '17px', fontWeight: '600', marginTop: '15px' }}>
          Mobile Number
        </Typography>
        <TextField
          fullWidth
          name="mobile"
          type="text"
          value={editData.mobile}
          onChange={handleInputChange}
          placeholder="Type your mobile number"
          sx={{
            borderRadius: '28px',
            border: '1px solid #362B24',
            '& .MuiOutlinedInput-root': {
              borderRadius: '25px',
            },
          }}
        />

        {/* Password Field */}
        <Typography sx={{ marginBottom: '8px', fontSize: '17px', fontWeight: '600', marginTop: '15px' }}>
         Change Password
        </Typography>
        <TextField
  fullWidth
  name="password"
  type={showPasswords.newPassword ? 'text' : 'password'} 
  value={editData.password}
  onChange={handleInputChange}
  placeholder="Type your password"
  sx={{
    borderRadius: '28px',
    border: '1px solid #362B24',
    '& .MuiOutlinedInput-root': {
      borderRadius: '25px',
    },
  }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <img
          src={showPasswords.newPassword ? OpenEyeIcon : CloseEyeIcon}
          alt="toggle-password-visibility"
          onClick={() => handleClickShowPassword('newPassword')} // Corrected field name
          className="toggle-password-icon"
          style={{ cursor: 'pointer' }} // Ensure it's clear that it's clickable
        />
      </InputAdornment>
    ),
  }}
/>


        {/* Retype Password Field */}
        <Typography sx={{ marginBottom: '8px', fontSize: '17px', fontWeight: '600', marginTop: '15px' }}>
          Retype Change Password
        </Typography>
        <TextField
  fullWidth
  name="retypePassword"
  type={showPasswords.confirmNewPassword ? 'text' : 'password'} 
  value={editData.retypePassword}
  onChange={handleInputChange}
  placeholder="Retype your password"
  sx={{
    borderRadius: '28px',
    border: '1px solid #362B24',
    '& .MuiOutlinedInput-root': {
      borderRadius: '25px',
    },
  }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        <img
          src={showPasswords.confirmNewPassword ? OpenEyeIcon : CloseEyeIcon}
          alt="toggle-password-visibility"
          onClick={() => handleClickShowPassword('confirmNewPassword')} // Corrected field name
          className="toggle-password-icon"
          style={{ cursor: 'pointer' }} // Ensure it's clear that it's clickable
        />
      </InputAdornment>
    ),
  }}
/>


        {/* User Permissions */}
        <Typography sx={{ marginTop: '20px', marginBottom: '10px', fontSize: '17px', fontWeight: '600', marginLeft: '10px' }}>
          User Permissions
        </Typography>
        <Grid container  spacing={gridSpacing}>
          {permissions.map((permission, index) => (
            <Grid item xs={6}  sm={4} key={index}>
              <FormControlLabel
                control={
                  <CustomCheckbox
                    checked={editData.permissions?.[index] || false}
                    onChange={() => handleCheckboxChange(index)}
                  />
                }
                label={permission}
              />
            </Grid>
          ))}
        </Grid>

        {/* Save Button */}
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            sx={{
              mt: 2,
              width: '323px',
              height: '57px',
              borderRadius: '28.5px',
              background: 'linear-gradient(180deg, #065F46 0%, #0D7B5C 100%)',
              color: 'white',
              textTransform: 'none',
              fontSize: '16px',
              fontWeight: '600',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onClick={handleSave}
          >
            Update
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditUserPermission;
